import { Box, Typography, Button } from '@mui/material';
import { motion } from 'framer-motion';
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";


const Hero = () => {
  return (
    <Box
      sx={{
        height: '100vh',
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65)), url(/images/livingroom.jpeg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        color: '#fff',
        textAlign: 'center',
        px: 2,
      }}
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2 }}
      >
    <Typography
  variant="h2"
  sx={{
   fontFamily: 'Helvetica, Arial, sans-serif',
   fontSize:{sm:"70px",xs:"32px"},
    fontWeight: 'bold',
    lineHeight: 1.2,
  }}
>
  <span style={{ color: '#fff' }}>Transform Your</span>{' '}
  <span style={{ color: '#C29D59' }}>Space</span>
  <br />
  <span style={{ color: '#C29D59' }}>With Elegance</span>
</Typography>


        <Typography variant="h6" sx={{ mt: 2,fontSize:{xs:"16px"} }}>
          We create interiors that inspire comfort and luxury.
        </Typography>

        <Button
                    variant="outlined"
                    endIcon={<ArrowOutwardIcon />}
                    sx={{
                      alignSelf: "flex-start",
                      mt: 3,
                      borderColor: "#d2ad6d",
                      borderRadius: "30px",
                      color: "white",
                      
                      px: 3,
                      py: 1.2,
                      textTransform: "none",
                      fontWeight: "bold",
                      "&:hover": {
                        backgroundColor: "#d2ad6d",
                        color: "#000",
                      },
                    }}
                  >
                    Explore Our Work
                  </Button>
      </motion.div>
    </Box>
  );
};

export default Hero;
